import {isEmpty} from 'lodash'
import Moment from 'moment'
import * as Constants from './constants'
import * as Types from './types'

const dropDownStartDateSelector = (dateValue: Types.dateValue) => {
  switch (dateValue) {
    case Constants.DATE_SELECT_TODAY_MODE:
    case Constants.DATE_SELECT_NEXT_WEEK_MODE:
      return Moment().format('YYYY-MM-DD')
    case Constants.DATE_SELECT_TOMORROW_MODE:
      return Moment().add(1, 'day').format('YYYY-MM-DD')
    default:
      return null
  }
}

export const convertStartDateToDateString =
(dateSelect: Types.dateSelect, selectedDate: Types.SelectedDate): string => {
  const d = dropDownStartDateSelector(dateSelect)
  if (!isEmpty(d)) {
    return d
  } else if (isEmpty(selectedDate)) {
    return Moment().format('YYYY-MM-DD')
  } else {
    return Moment(selectedDate).format('YYYY-MM-DD')
  }
}

const dropDownEndDateSelector = (dateValue: Types.dateValue) => {
  switch (dateValue) {
    case Constants.DATE_SELECT_TODAY_MODE:
      return Moment().add(1, 'day').format('YYYY-MM-DD')
    case Constants.DATE_SELECT_TOMORROW_MODE:
        return Moment().add(2, 'day').format('YYYY-MM-DD')
    case Constants.DATE_SELECT_NEXT_WEEK_MODE:
      return Moment().add(1, 'week').format('YYYY-MM-DD')
    default:
      return null
  }
}

export const convertEndDateToDateString =
(dateSelect: Types.dateSelect, selectedDate: Types.SelectedDate): string => {
  const d = dropDownEndDateSelector(dateSelect)
  if (!isEmpty(d)) {
    return d
  } else if (isEmpty(selectedDate)) {
    return Moment().add(1, 'day').format('YYYY-MM-DD')
  } else {
    return Moment(selectedDate).add(1, 'day').format('YYYY-MM-DD')
  }
}



// WEBPACK FOOTER //
// ./src/pages/upcoming-schedules/utils.ts